/**
 * Delegated click tracking pushed into the GTM dataLayer (see layout/theme.liquid for the
 * GTM-MZ2VVLQK container snippet). One constant event name ('site_click') with category/
 * action/label/url fields, so GTM only needs a single Custom Event trigger + GA4 tag.
 */
(function () {
  function push(category, action, label, url) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'site_click',
      click_category: category,
      click_action: action,
      click_label: (label || '').trim(),
      click_url: url || ''
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target;

    var wishlistIcon = el.closest('[data-wishlist-icon]');
    if (wishlistIcon) {
      push('wishlist', 'header_icon', 'Wishlist', wishlistIcon.getAttribute('href') || '');
      return;
    }

    var wishlistBtn = el.closest('[data-wishlist-button]');
    if (wishlistBtn) {
      // Fires after the button's own click handler (bound directly on it, so it runs during
      // the target phase before the event bubbles here) has already toggled aria-pressed.
      var nowSaved = wishlistBtn.getAttribute('aria-pressed') === 'true';
      push('wishlist', 'product_toggle', nowSaved ? 'saved' : 'removed', '');
      return;
    }

    var locLink = el.closest('.announcement-bar_link');
    if (locLink) {
      var text = locLink.textContent.trim();
      var action = /add/i.test(text) ? 'add_location' : 'change_location';
      push('location_switcher', action, text, locLink.getAttribute('href') || '');
      return;
    }

    var toolbarCard = el.closest('.mgmt-toolbar__card');
    if (toolbarCard) {
      var toolbarLabel = toolbarCard.querySelector('.mgmt-toolbar__label');
      push('mgmt_toolbar', 'card', toolbarLabel ? toolbarLabel.textContent : toolbarCard.textContent, toolbarCard.getAttribute('href') || '');
      return;
    }

    // Channel-specific "Categories" sidebar (collection-channel-sidebar-grid.liquid). Scoped
    // to this BEM child class, not the generic .channel-sidebar wrapper - that wrapper is
    // reused for the nested Shop-by-Product aside on the same page too.
    var channelSidebarLink = el.closest('.channel-sidebar__link');
    if (channelSidebarLink) {
      var catLabel = channelSidebarLink.querySelector('.channel-sidebar__label');
      push('channel_categories', 'sidebar_menu', catLabel ? catLabel.textContent : channelSidebarLink.textContent, channelSidebarLink.getAttribute('href') || '');
      return;
    }

    // "Shop by Channel" quick-nav widget (shop-by-channel-menu.liquid) - the only sidebar
    // wrapper with the --channels modifier.
    var channelWidgetLink = el.closest('.sidebar-cs--channels a[href]');
    if (channelWidgetLink) {
      var chLabel = channelWidgetLink.querySelector('.sidebar-cs__label');
      push('shop_by_channel', 'sidebar_widget', chLabel ? chLabel.textContent : channelWidgetLink.textContent, channelWidgetLink.getAttribute('href'));
      return;
    }

    // "Shop by Product" sidebar (sidebar-static-menu.liquid) - no single link class spans all
    // 3 nesting levels there, so delegate on the wrapper + tag instead, same as that file's
    // own existing auto-open script does.
    var productSidebarLink = el.closest('.sidebar-cs:not(.sidebar-cs--channels) a[href]');
    if (productSidebarLink) {
      push('shop_by_product', 'sidebar_menu', productSidebarLink.textContent, productSidebarLink.getAttribute('href'));
      return;
    }

    // "Shop by Channel" header nav item + all of its submenu/grandchild descendants. Matched
    // by the top-level <li>'s own label text rather than Shopify's auto-generated handle/id,
    // since the handle depends on exactly how the Admin nav item is titled and can't be
    // verified from theme code.
    var headerLi = el.closest('.header__inline-menu > ul > li');
    if (headerLi) {
      var topLabelEl = headerLi.querySelector(':scope > header-menu summary, :scope > a');
      var topLabel = topLabelEl ? topLabelEl.textContent.trim() : '';
      if (/^shop\s*by\s*channel$/i.test(topLabel)) {
        var clickedLink = el.closest('a[href]') || el.closest('summary');
        var clickedLabel = clickedLink ? clickedLink.textContent.trim() : topLabel;
        var clickedUrl = clickedLink && clickedLink.tagName === 'A' ? clickedLink.getAttribute('href') : '';
        push('shop_by_channel', 'header_nav', clickedLabel, clickedUrl);
      }
    }
  });
})();
